var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "flex",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSearch.apply(null, arguments)
        },
      },
    },
    [
      _c("Search", {
        staticClass: "w-60 mr-4",
        attrs: { debounceTime: 0 },
        on: { search: _vm.onSearchUpdate },
      }),
      _c("UiButton", {
        attrs: { buttonText: "Search" },
        on: { click: _vm.onSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }